import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { defaultSizes, TextStyled } from './text';
/**
 * A component to control font size and style for heading elements.
 *
 * This should be used for all heading levels from 1-6.
 */
export const Heading = memo(({ as = 'h1', children, sizes, className, mb = 0, color = 'currentColor', }) => {
    const elementName = as.toString();
    const defaultSize = defaultSizes[elementName];
    return (_jsx(TextStyled, { as: as, isHeading: true, sizes: sizes !== undefined ? sizes : defaultSize, className: className, mb: mb, color: color, children: children }));
});
//# sourceMappingURL=heading.js.map